export default {
    privacy: {
        title: 'Privacy'
    }
};
